import clsx from 'clsx';

import PropTypes from 'prop-types';

const CalendarCellMonth = ({ isToday, dayNumberText }) => {
    return (
        <div
            className={clsx('mt-0.5 flex w-full justify-center text-9', {
                'text-white': isToday,
                'text-icoGray-500': !isToday
            })}>
            <span className="relative">
                {isToday ? (
                    <span
                        data-testid="background-cell-month-today-date"
                        className="absolute left-1/2 top-1/2 h-3.5 w-3.5 -translate-x-1/2 -translate-y-1/2 transform rounded-full bg-icoBlue"
                    />
                ) : null}
                <span className="relative z-1">{dayNumberText}</span>
            </span>
        </div>
    );
};

CalendarCellMonth.propTypes = {
    isToday: PropTypes.bool.isRequired,
    dayNumberText: PropTypes.string.isRequired
};

export default CalendarCellMonth;
